import { useRateScheduleDigest, useRateNames } from "../../../../../RatesDigest/RatesDigestContext";
import { useRateContext } from "../../../../Context/RateContext";

export interface EligibleReferenceRate {
  id: string;
  name: string;
  endDate: Date;
}

export const useEligibleReferenceRates = (): EligibleReferenceRate[] => {
  const { rateIndex } = useRateContext();
  const scheduleDigest = useRateScheduleDigest();
  const names = useRateNames();

  return scheduleDigest.flatMap((rate, index) =>
    index !== rateIndex && rate.isScheduled && rate.salesEndMode === "customDate" && rate.salesEndDate
      ? [{ id: rate.id, name: names[index] ?? "", endDate: new Date(rate.salesEndDate) }]
      : []
  );
};
